import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import PricingPage from "@/pages/PricingPage";
import AuthPage from "@/pages/AuthPage";
import NurseDashboard from "@/pages/NurseDashboard";
import AdherenceReportsPage from "@/pages/AdherenceReportsPage";
import SvaDetoxPrivacy from "@/pages/legal/SvaDetoxPrivacy";
import SvaDetoxTerms from "@/pages/legal/SvaDetoxTerms";
import SvaDetoxRefunds from "@/pages/legal/SvaDetoxRefunds";

const HIDE_SHELL_ROUTES = ['/auth', '/login', '/signup', '/nurse-dashboard', '/adherence-reports'];

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppShell({ children }) {
  const location = useLocation();
  const hideShell = HIDE_SHELL_ROUTES.some(r => location.pathname.startsWith(r));
  return (
    <>
      {!hideShell && <Navbar />}
      <main>{children}</main>
      {!hideShell && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-[#020617]">
      <BrowserRouter>
        <ScrollToTop />
        <AppShell>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products/sva-detox" element={<ProductsPage />} />
            <Route path="/products/sva-detox/privacy" element={<SvaDetoxPrivacy />} />
            <Route path="/products/sva-detox/terms" element={<SvaDetoxTerms />} />
            <Route path="/products/sva-detox/refunds" element={<SvaDetoxRefunds />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/signup" element={<AuthPage />} />
            <Route path="/nurse-dashboard" element={<NurseDashboard />} />
            <Route path="/adherence-reports" element={<AdherenceReportsPage />} />
          </Routes>
        </AppShell>
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
